/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  OauthApplication,
  OauthApplicationInput,
  OauthApplicationUpdateInput,
  OauthApplicationWithSecret,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create OAuth Application
 */
export const createOauthApplication = (
    oauthApplicationInput: MaybeRefOrGetter<OauthApplicationInput>,
 signal?: AbortSignal
) => {
      oauthApplicationInput = toValue(oauthApplicationInput);

      return axiosClient<OauthApplicationWithSecret>(
      {url: `/oauth-applications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: oauthApplicationInput, signal
    },
      );
    }




export const getCreateOauthApplicationMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOauthApplication>>, TError,{data: OauthApplicationInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createOauthApplication>>, TError,{data: OauthApplicationInput}, TContext> => {

const mutationKey = ['createOauthApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createOauthApplication>>, {data: OauthApplicationInput}> = (props) => {
          const {data} = props ?? {};

          return  createOauthApplication(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateOauthApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof createOauthApplication>>>
    export type CreateOauthApplicationMutationBody = OauthApplicationInput
    export type CreateOauthApplicationMutationError = ErrorType<ValidationError | StandardError>

    /**
 * @summary Create OAuth Application
 */
export const useCreateOauthApplication = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createOauthApplication>>, TError,{data: OauthApplicationInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createOauthApplication>>,
        TError,
        {data: OauthApplicationInput},
        TContext
      > => {
      return useMutation(getCreateOauthApplicationMutationOptions(options), queryClient);
    }
    /**
 * @summary OAuth Applications list
 */
export const oauthApplications = (

 signal?: AbortSignal
) => {


      return axiosClient<OauthApplication[]>(
      {url: `/oauth-applications`, method: 'GET', signal
    },
      );
    }




export const getOauthApplicationsQueryKey = () => {
    return [
    'oauth-applications'
    ] as const;
    }


export const getOauthApplicationsQueryOptions = <TData = Awaited<ReturnType<typeof oauthApplications>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthApplications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getOauthApplicationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oauthApplications>>> = ({ signal }) => oauthApplications(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oauthApplications>>, TError, TData>
}

export type OauthApplicationsQueryResult = NonNullable<Awaited<ReturnType<typeof oauthApplications>>>
export type OauthApplicationsQueryError = ErrorType<StandardError>


/**
 * @summary OAuth Applications list
 */

export function useOauthApplications<TData = Awaited<ReturnType<typeof oauthApplications>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthApplications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOauthApplicationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy OAuth Application
 */
export const destroyOauthApplication = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/oauth-applications/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyOauthApplicationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyOauthApplication>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyOauthApplication>>, TError,{id: string}, TContext> => {

const mutationKey = ['destroyOauthApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyOauthApplication>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  destroyOauthApplication(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyOauthApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof destroyOauthApplication>>>

    export type DestroyOauthApplicationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Destroy OAuth Application
 */
export const useDestroyOauthApplication = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyOauthApplication>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyOauthApplication>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDestroyOauthApplicationMutationOptions(options), queryClient);
    }
    /**
 * @summary OAuth Application detail
 */
export const oauthApplication = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<OauthApplication>(
      {url: `/oauth-applications/${id}`, method: 'GET', signal
    },
      );
    }




export const getOauthApplicationQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'oauth-applications',id
    ] as const;
    }


export const getOauthApplicationQueryOptions = <TData = Awaited<ReturnType<typeof oauthApplication>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthApplication>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getOauthApplicationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof oauthApplication>>> = ({ signal }) => oauthApplication(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof oauthApplication>>, TError, TData>
}

export type OauthApplicationQueryResult = NonNullable<Awaited<ReturnType<typeof oauthApplication>>>
export type OauthApplicationQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary OAuth Application detail
 */

export function useOauthApplication<TData = Awaited<ReturnType<typeof oauthApplication>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthApplication>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getOauthApplicationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update OAuth Application
 */
export const updateOauthApplication = (
    id: MaybeRefOrGetter<string>,
    oauthApplicationUpdateInput: MaybeRefOrGetter<OauthApplicationUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
oauthApplicationUpdateInput = toValue(oauthApplicationUpdateInput);

      return axiosClient<OauthApplication>(
      {url: `/oauth-applications/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: oauthApplicationUpdateInput, signal
    },
      );
    }




export const getUpdateOauthApplicationMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOauthApplication>>, TError,{id: string;data: OauthApplicationUpdateInput}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateOauthApplication>>, TError,{id: string;data: OauthApplicationUpdateInput}, TContext> => {

const mutationKey = ['updateOauthApplication'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOauthApplication>>, {id: string;data: OauthApplicationUpdateInput}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOauthApplication(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOauthApplicationMutationResult = NonNullable<Awaited<ReturnType<typeof updateOauthApplication>>>
    export type UpdateOauthApplicationMutationBody = OauthApplicationUpdateInput
    export type UpdateOauthApplicationMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Update OAuth Application
 */
export const useUpdateOauthApplication = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOauthApplication>>, TError,{id: string;data: OauthApplicationUpdateInput}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateOauthApplication>>,
        TError,
        {id: string;data: OauthApplicationUpdateInput},
        TContext
      > => {
      return useMutation(getUpdateOauthApplicationMutationOptions(options), queryClient);
    }
    /**
 * @summary Regenerate OAuth Application secret
 */
export const regenerateOauthApplicationSecret = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<OauthApplicationWithSecret>(
      {url: `/oauth-applications/${id}/regenerate-secret`, method: 'PUT', signal
    },
      );
    }




export const getRegenerateOauthApplicationSecretMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateOauthApplicationSecret>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof regenerateOauthApplicationSecret>>, TError,{id: string}, TContext> => {

const mutationKey = ['regenerateOauthApplicationSecret'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateOauthApplicationSecret>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  regenerateOauthApplicationSecret(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateOauthApplicationSecretMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateOauthApplicationSecret>>>

    export type RegenerateOauthApplicationSecretMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>

    /**
 * @summary Regenerate OAuth Application secret
 */
export const useRegenerateOauthApplicationSecret = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateOauthApplicationSecret>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof regenerateOauthApplicationSecret>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRegenerateOauthApplicationSecretMutationOptions(options), queryClient);
    }
